import type { FaireProductEntity } from "../../entity_types/product";

export const p_q7hp7459nh: FaireProductEntity = {
  token: "p_q7hp7459nh",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Chain Necklace - 7802",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/bc1964b9bd65aaee967c42a7ee19b70ad9ed35848ab9e2731a959da2b79a10ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a49326016c97fd9e39e23e71b3dff2b6f552d8b2e9b3f23af0d1fe307a74d274.jpeg",
    "https://cdn.faire.com/fastly/df7447c2b0c2224e23adc38a4a80f3fbe289c7dce03821f50277a5b83cdd182a.jpeg",
    "https://cdn.faire.com/fastly/b001baf633f3dfe130eab9532effa39e081d9a027752423f628d4e22bf36b3f1.jpeg",
    "https://cdn.faire.com/fastly/98ed86bec15b648fae29c31cb9dae65683086acb8a73bbbf856c8354b0201c30.jpeg",
    "https://cdn.faire.com/fastly/5f80cabd6ff18f1202772871819df7769bbd3e1c2946559b00728f83ee622171.jpeg",
    "https://cdn.faire.com/fastly/2d9a0c1ebbf061e85ee3d5dd8bcb65d4893214360281339400a471b4aab14440.jpeg",
  ],
  priceDollars: 8.66,
  description:
    '18K Gold Dipped Stainless Steel Pearl Necklace.\nApprox. 17.75" L + 2" extender.\n\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\nPearl Necklace | Double Herringbone Chain Necklace | Real Gold Dipped Necklace | Real Gold Plated Necklace | Waterproof & Sweatproof Necklace | Layering Necklace | Simple Gold Necklace\n',
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:39.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
